<template>
  <div>
    <v-dialog ref="dialog" persitent v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          {{ text }}
          <div v-if="content">
            <span>Escolha o melhor horário para as aulas </span>
            <v-row dense class="mt-2">
              <v-col
                class="d-flex align-center justify-start"
                cols="12"
                v-for="(hour, index) in content"
                :key="index"
                style="height: auto"
              >
                <v-checkbox
                  v-model="selectedItems"
                  :key="index"
                  :label="`${displayWeekDay(hour.weekDay)} - ${hour.from} até ${
                    hour.to
                  } `"
                  :value="hour"
                  dense
                  :disabled="disableItems && !selectedItems.includes(hour)"
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <span style="font-size: 0.8rem"
            >De acordo com sua preferência escolha no mínimo
            <strong>{{ limit }}</strong>
            {{ limit === 1 ? "opção" : "opções" }}</span
          >
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="selectedItems.length < limit"
            @click="confirm"
          >
            Solicitar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "confirmation-dialog",
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    item: {
      type: [Object, null],
    },
    content: {
      type: [Array, null],
    },
    limit: {
      type: Number,
    },
  },
  data() {
    return {
      dialog: false,
      selectedItems: [],
      disableItems: false,
      days: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("cancel");
    },
    confirm() {
      let data = Object.assign({}, this.item);
      if (this.content.length > 0) {
        data["hours"] = this.selectedItems;
      }
      this.$emit("confirmed", data);
      this.dialog = false;
    },
    displayWeekDay(day) {
      return this.days.find((d) => d.value === +day).text;
    },
  },
};
</script>

<style lang="css" scoped></style>
